import React from "react";
import { Modal, Image, Header } from "semantic-ui-react";
import logo from "../assets/images/urbansim/logo.png";
import { externalLinks, termsOfServiceLink, privacyPolicyLink } from "../config/config";

type AboutProps = {
  open: boolean;
  onClose: () => void;
};

const About = ({ open, onClose }: AboutProps) => {
  const handleClose = (event: React.MouseEvent<HTMLElement, MouseEvent>) => {
    event.stopPropagation();
    onClose();
  };
  return (
    <Modal size="small" open={open} onClose={handleClose} closeIcon trigger={<div>About</div>}>
      <Modal.Header>About</Modal.Header>
      <Modal.Content image>
        <Image size="small" src={logo} wrapped aria-label="Urbancanvas logo" />
        <Modal.Description>
          <Header as="h3">Account Manager</Header>
          <p>
            © {new Date().getFullYear()}
            <a className="link" href={externalLinks.urbansim}>
              {" "}
              UrbanSim Inc.
            </a>{" "}
            ALL RIGHTS RESERVED
          </p>
          <p>
            <a className="link" href={termsOfServiceLink}>
              Terms of Service
            </a>
          </p>
          <p>
            <a className="link" href={privacyPolicyLink}>
              Privacy Policy
            </a>
          </p>
        </Modal.Description>
      </Modal.Content>
    </Modal>
  );
};

export default About;
